const LOWERCASE = 'acdefhjkmnpqrtuvwxy';
const UPPERCASE = 'ACDEFHJKLMNPQRTUVWXY';
const DIGITS = '34679';
const SPECIALS = '!@#$%^*&';

const ALL = `${LOWERCASE}${UPPERCASE}${DIGITS}${SPECIALS}`;

export const GENERATED_PASSWORD_LENGTH = 12;

const randomValues = (length: number): number[] => {
  const crypto = typeof window !== 'undefined' ? window.crypto : undefined;
  if (crypto && crypto.getRandomValues) {
    return Array.from(crypto.getRandomValues(new Uint32Array(length)));
  }
  return Array.from({ length }, () => Math.floor(Math.random() * 0xffffffff));
};

const pick = (charset: string, value: number): string =>
  charset[value % charset.length];

/**
 * Generates a 12 character password built only from unambiguous characters,
 * with at least one lowercase, one uppercase, one digit and one special
 * character, as required by the platform password rules.
 */
export const generatePassword = (): string => {
  const size = GENERATED_PASSWORD_LENGTH;
  const values = randomValues(size * 2);
  const characters = [
    pick(LOWERCASE, values[0]),
    pick(UPPERCASE, values[1]),
    pick(DIGITS, values[2]),
    pick(SPECIALS, values[3]),
    ...values.slice(4, size).map(value => pick(ALL, value)),
  ];
  for (let i = characters.length - 1; i > 0; i -= 1) {
    const j = values[size + i] % (i + 1);
    [characters[i], characters[j]] = [characters[j], characters[i]];
  }
  return characters.join('');
};

export default generatePassword;
